import { useState, useEffect } from 'react';
import { localStorageGetItem } from 'entrypoints/storage_helpers';

const useIsFilledLeadForm = () => {
  const [isFilledLeadForm, setIsFilledLeadForm] = useState(false);

  useEffect(() => {
    setIsFilledLeadForm(!!localStorageGetItem('filledLeadForm'));
  }, []);

  return isFilledLeadForm;
};

export default useIsFilledLeadForm;
